const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const subscriberCache = new Map();
const permanentCache = new Map();

const SOCIAL_MEDIA_CONFIG_PATH = 'config/social-media.json';
const SUBSCRIBERS_PATH = 'config/subscribers.json';

export const fetchSubscribers = async () => {
  try {
    // Return cached subscribers immediately if available
    if (permanentCache.has('subscribers')) {
      return permanentCache.get('subscribers');
    }

    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SUBSCRIBERS_PATH}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      const result = { subscribers: JSON.parse(atob(data.content)), sha: data.sha };
      permanentCache.set('subscribers', result);
      return result;
    }
    return { subscribers: [], sha: null };
  } catch (error) {
    console.error('Error fetching subscribers:', error);
    return { subscribers: [], sha: null };
  }
};

export const saveSubscribers = async (subscribers, sha = null) => {
  try {
    const content = btoa(JSON.stringify(subscribers, null, 2));
    const body = {
      message: 'Update subscribers list',
      content,
      branch: 'main',
    };

    if (sha) {
      body.sha = sha;
    }

    await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SUBSCRIBERS_PATH}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    );
    permanentCache.delete('subscribers');
  } catch (error) {
    console.error('Error saving subscribers:', error);
    throw error;
  }
};

export const fetchSocialMediaConfig = async () => {
  try {
    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SOCIAL_MEDIA_CONFIG_PATH}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      const content = JSON.parse(atob(data.content));
      return { config: content, sha: data.sha };
    }
    return { 
      config: {
        facebook: { enabled: false, pageId: '', accessToken: '' },
        twitter: { enabled: false, apiKey: '', apiSecret: '', accessToken: '' },
        linkedin: { enabled: false, clientId: '', clientSecret: '', accessToken: '' }
      },
      sha: null 
    };
  } catch (error) {
    console.error('Error fetching social media config:', error);
    return { config: {}, sha: null };
  }
};

export const saveSocialMediaConfig = async (config, sha = null) => {
  try {
    const content = btoa(JSON.stringify(config, null, 2));
    const body = {
      message: 'Update social media configuration',
      content,
      branch: 'main',
    };

    if (sha) {
      body.sha = sha;
    }

    await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SOCIAL_MEDIA_CONFIG_PATH}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }
    );
  } catch (error) {
    console.error('Error saving social media config:', error);
    throw error;
  }
};

const refreshSubscribersInBackground = async () => {
  try {
    const response = await fetch(
      `https://api.github.com/repos/${process.env.REACT_APP_REPO_OWNER}/${process.env.REACT_APP_REPO_NAME}/contents/${SUBSCRIBERS_PATH}`,
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GITHUB_TOKEN}`,
          'Accept': 'application/vnd.github.v3+json',
        }
      }
    );

    if (response.ok) {
      const data = await response.json();
      const result = {
        subscribers: JSON.parse(atob(data.content)),
        sha: data.sha
      };
      subscriberCache.set('subscribers', {
        data: result,
        timestamp: Date.now()
      });
    }
  } catch (error) {
    console.error('Background refresh error:', error);
  }
};